import { useState, useEffect } from 'react'

export function useModal() {
  const [modal, setModal] = useState(null)

  useEffect(() => {
    if (!modal) return
    const handler = (e) => { if (e.key === 'Escape') setModal(null) }
    document.addEventListener('keydown', handler)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', handler)
      document.body.style.overflow = ''
    }
  }, [modal])

  return { modal, openModal: setModal, closeModal: () => setModal(null) }
}
